import React from 'react';
import ReactDOM from 'react-dom/client';  // Correct import for React 18 and later
import './index.css';
import App from './App';  // Correct import for App.js
import { BrowserRouter } from 'react-router-dom';  // Import BrowserRouter for routing

const root = ReactDOM.createRoot(document.getElementById('root')); // Create root element
root.render(                                 // Use render method on the root
  <React.StrictMode>
    <BrowserRouter basename='/'>  {/* Wrap App with BrowserRouter for routing */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
